import { ErrorBoundary } from "@platform/design-system";
import { HistoryRouter } from "@platform/navigation-control/react-router";

import { AppNavigationProvider, PortalContainer } from "./components";
import AppRoutes from "./components/appRoutes";
import FullPageError from "./components/fullPageError";
import JiraServiceDeskWidget from "./components/JiraServiceDeskWidget";
import useWalkMe from "./hooks/useWalkMe";
import Providers from "./Providers";
import { ConsultingRouteTracking } from "./utils/consultingRouteTracking";
import { DocumentTitle } from "./utils/documentTitle";

function App() {
  useWalkMe();

  return (
    <ErrorBoundary fallback={FullPageError}>
      <HistoryRouter>
        <AppNavigationProvider>
          <Providers>
            <ConsultingRouteTracking />
            <DocumentTitle />
            <JiraServiceDeskWidget />
            <PortalContainer>
              <AppRoutes />
            </PortalContainer>
          </Providers>
        </AppNavigationProvider>
      </HistoryRouter>
    </ErrorBoundary>
  );
}

export default App;
